<button #originRef (click)="showPopover()" [class.active]="dropdownOpen" class="button" mat-icon-button type="button">
  <span matBadge="{{(todos$ | async).allNotifCount}}"></span> <mat-icon  [icIcon]="icNotificationsActive"></mat-icon> 
</button>